import React, { useCallback, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from 'react-redux';
import FaqModal from "src/components/FaqModal";
import ReactRoutes from "src/constants/react-routes";
import store from 'src/redux/store';
import ContactHelpScreen from './alumni/ContactHelpScreen';
import ContactInfoSelectScreen from './alumni/ContactInfoSelectScreen';
import WelcomeScreen from './alumni/WelcomeScreen';
import Help from './alumni/Help';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react'
import PrivacyPolicyView from './alumni/PrivacyPolicyView';
import PbForbiddenPage from "src/components/error/PbForbidden";
import PasskeyHelp from './passkey/PasskeyHelp';
import {
    showPbModal,
    showCsgoModal,
    showNewActivationFlow
} from 'src/constants/feature-gates';
import CSGORegionSelectionScreen from './csgo/CSGORegionSelectionScreen';
import VerifyAccountScreen from "src/components/alumni/VerifyAccountScreen";
import CreateAccountScreen from "src/components/alumni/CreateAccountScreen";
import InvalidLinkScreen from "src/components/alumni/InvalidLinkScreen";
import ForcedAeaScreen from "src/components/aea/ForcedAeaScreen";
import DeconsolidatedLoginScreenV2 from "src/components/DeconsolidatedLoginScreenV2";

function App() {
    const activationFlowEnabled = showNewActivationFlow();
    const scopeRef = useRef<HTMLDivElement>(null);

    // Reads current design-token CSS variables from the StencilProvider scope
    // and applies them to document.body. This is needed because StencilProvider
    // scopes --st-dt-* vars to its wrapper div, making them unreachable by body.
    const syncBodyStyles = useCallback(() => {
        if (!scopeRef.current) return;
        const styles = getComputedStyle(scopeRef.current);
        document.body.style.backgroundColor = styles.getPropertyValue('--st-dt-color-surface-bg-default').trim();
        document.body.style.color = styles.getPropertyValue('--st-dt-color-text-primary').trim();
    }, []);

    useEffect(() => {
        syncBodyStyles();
        return () => {
            document.body.style.backgroundColor = '';
            document.body.style.color = '';
        };
    }, [syncBodyStyles]);

    return (
        <div ref={scopeRef} style={{display: 'contents'}}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistStore(store)}>
                    <BrowserRouter>
                        <Routes>
                            <Route path={ReactRoutes.ROOT} element={<DeconsolidatedLoginScreenV2 />} />
                            <Route path={ReactRoutes.WELCOME} element={<WelcomeScreen />} />
                            <Route path={ReactRoutes.ALUMNI_WELCOME} element={<WelcomeScreen />} />
                            <Route path={ReactRoutes.ALUMNI_CONTACT_HELP} element={<ContactHelpScreen /> } />
                            <Route path={ReactRoutes.ALUMNI_CONTACT_SELECT} element={<ContactInfoSelectScreen /> } />
                            <Route path={ReactRoutes.ALUMNI_FAQ} element={<Help /> } />
                            <Route path={ReactRoutes.PRIVACY_POLICY} element={<PrivacyPolicyView /> } />
                            {activationFlowEnabled && <Route path={ReactRoutes.ALUMNI_VERIFY_ACCOUNT_REQUEST} element={<VerifyAccountScreen /> } />}
                            {activationFlowEnabled && <Route path={ReactRoutes.ALUMNI_CREATE_ACCOUNT} element={<CreateAccountScreen /> } />}
                            {activationFlowEnabled && <Route path={ReactRoutes.ALUMNI_ERROR_SCREEN} element={<InvalidLinkScreen />} />}
                            {showPbModal() && <Route path={ReactRoutes.PREBOARDER_FORBIDDEN} element={<PbForbiddenPage />} /> }
                            {showCsgoModal() && <Route path={ReactRoutes.CSGO_REGION} element={<CSGORegionSelectionScreen /> } />}
                            <Route path={ReactRoutes.FORCED_AEA} element={<ForcedAeaScreen />} />
                            <Route path={ReactRoutes.PASSKEY_HELP} element={<PasskeyHelp />} />
                        </Routes>
                    </BrowserRouter>
                    <FaqModal />
                </PersistGate>
            </Provider>
        </div>
    );
}

export default App;
